'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography2.cjs.map
